import { RequestError } from '@/domain/shared/errors';

export function isMissingReportError(error: unknown): boolean {
    return RequestError.isRequestError(error) && error.status === 404;
}
